import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { StableName } from '../../utils/racing-game/horses.ts';
import { HorseName } from "../../utils/racing-game/consts.ts";

type GameSettings = {
  single: {
    name: Nullish<HorseName>;
    amount: number;
  };
  stable: {
    name: Nullish<StableName>;
    amount: number;
  };
  setSingleHorseData: (data: SingleHorseData) => void;
  setStableData: (data: StableData) => void;
};

export const useMobileNewBetsStore = create<GameSettings>()(
  immer((set) => ({
    single: {
      name: null,
      amount: 0,
    },
    stable: {
      name: null,
      amount: 0,
    },
    setSingleHorseData: (data) =>
      set((state) => {
        state.single = {
          ...state.single,
          ...data,
        };
      }),
    setStableData: (data) =>
      set((state) => {
        state.stable = {
          ...state.stable,
          ...data,
        };
      }),
  }))
);

type SingleHorseData = AtLeastOne<{ name: Nullish<HorseName>; amount: number }>;
type StableData = AtLeastOne<{ name: Nullish<StableName>; amount: number }>;
